import MuiClickAwayListener, {
  type ClickAwayListenerProps,
} from "@mui/material/ClickAwayListener";

export type { ClickAwayListenerProps };

export function ClickAwayListener(props: ClickAwayListenerProps) {
  return <MuiClickAwayListener {...props} />;
}
